import moment from "moment";

import { ANNOUNCEMENT_DISMISSED, GET_ANNOUNCEMENTS_COMPLETED } from "../constants";
import { ANNOUNCEMENT_TYPE } from "../models/announcements";

import type {
  Announcement,
  AnnouncementMessage,
  AnnouncementsState,
  UpgradeAnnouncement,
} from "../models/announcements";

const initialState = {
  systemAnnouncements: [],
  updatedTimestamp: undefined,
  upgradeAnnouncements: [],
};

const reducer = (state = initialState, action: any) => {
  switch (action.type) {
    case GET_ANNOUNCEMENTS_COMPLETED: {
      return handleGetAnnouncementsCompleted(state, action.payload);
    }

    case ANNOUNCEMENT_DISMISSED: {
      return handleDismissAnnouncement(state, action.payload);
    }

    default: {
      return state;
    }
  }
};

const handleGetAnnouncementsCompleted = (
  state: AnnouncementsState,
  announcements: Announcement[],
) => {
  const dismissedStorage = localStorage.getItem("dismissed-announcements") || "[]";
  const dismissed: string[] = JSON.parse(dismissedStorage);
  const activeAnnouncements = announcements.filter(
    (announcement) => !dismissed.includes(announcement.Id),
  );
  const systemAnnouncements: Announcement[] = [];
  const upgradeAnnouncements: UpgradeAnnouncement[] = [];

  activeAnnouncements.forEach((announcement) => {
    try {
      const data: AnnouncementMessage = JSON.parse(announcement.Message);

      if (data && moment().isBefore(moment(announcement.ExpirationDate))) {
        let { message } = data;
        const matches = data.message.matchAll(/\{([^}]+)\}/g);
        const parameters = Array.from(matches).map((match) => match[0]);

        parameters.forEach((parameter) => {
          const paramName = parameter.slice(1, -1);
          const paramValue = data[paramName] ?? "";

          const utcMoment = moment.utc(paramValue);

          if (utcMoment.isValid()) {
            const localMoment = utcMoment.local();
            const value = localMoment.format("MM/DD/YYYY h:mm A");

            message = message.replace(
              parameter,
              data.type === ANNOUNCEMENT_TYPE.UPGRADE ? `**${value}**` : value,
            );
          } else {
            message = message.replace(parameter, paramValue);
          }
        });

        if (data.type === ANNOUNCEMENT_TYPE.UPGRADE) {
          upgradeAnnouncements.push({
            ...announcement,
            Message: message,
            version: data.version,
          });
        } else {
          systemAnnouncements.push({ ...announcement, Message: message });
        }
      }
    } catch {
      systemAnnouncements.push(announcement);
    }
  });

  return {
    ...state,
    systemAnnouncements,
    updatedTimestamp: Date.now(),
    upgradeAnnouncements,
  };
};

const handleDismissAnnouncement = (state: AnnouncementsState, id: string): AnnouncementsState => {
  const dismissedStorage = localStorage.getItem("dismissed-announcements") || "[]";
  const dismissed: string[] = JSON.parse(dismissedStorage);

  dismissed.push(id);

  localStorage.setItem("dismissed-announcements", JSON.stringify(dismissed));

  return {
    ...state,
    systemAnnouncements: state.systemAnnouncements.filter((item) => item.Id !== id),
    updatedTimestamp: Date.now(),
    upgradeAnnouncements: state.upgradeAnnouncements.filter((item) => item.Id !== id),
  };
};

export default reducer;
